import React from "react";

const BookingInstructions = () => (
  <p className="booking-instructions">
    Click the "Book Now" button to see services/pricing for online booking.<br />
    Please text/call 865-724-8275 to inquire about in-home massage.<br />
  </p>
);

export default BookingInstructions;